import React from 'react';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';
import { css } from '@emotion/core';

import ColorProvider from '../chrome/ColorProvider';
import Text from '../chrome/Text';
import Radio from '../chrome/Radio';
import ImageWithFrame from '../ui/ImageWithFrame';

const baseStyles = () => css`
  width: 100%;
  min-width: 200px;
  display: flex;
  align-items: center;
`;

const Container = styled('div')(baseStyles);

const radioImageBaseStyles = ({ theme }) =>
  css`
    margin-right: ${theme.spacings.kilo};
  `;

const RadioImage = styled('div')(radioImageBaseStyles);

const radioDetailsBaseStyles = ({ theme, centered }) =>
  !centered &&
  css`
    margin-right: ${theme.spacings.exa};
  `;

const radioDetailsCenteredStyles = ({ centered }) =>
  centered &&
  css`
    text-align: center;
    margin: 0 auto;
    width: 100%;
  `;

const RadioDetails = styled('div')(radioDetailsBaseStyles, radioDetailsCenteredStyles);

const headingContainerBaseStyles = () => css`
  margin-left: 20px;
`;

const HeadingContainer = styled('div')(headingContainerBaseStyles);

const radioSelectorBaseStyles = () => css`
  margin-left: auto;
`;

const RadioSelector = styled('div')(radioSelectorBaseStyles);

const RadioCard = ({ itemId, assetUrl, title, text, centered, selected, titleProps, onSelect }) => (
  <Container onClick={() => onSelect(itemId)}>
    {assetUrl && (
      <RadioImage>
        <ImageWithFrame assetUrl={assetUrl} size='tera' noBorder />
      </RadioImage>
    )}
    <RadioDetails centered={centered}>
      {title &&
        (centered ? (
          <HeadingContainer>
            <ColorProvider variant='brown'>
              <Text size='tera' noMargin {...titleProps}>
                {title}
              </Text>
            </ColorProvider>
          </HeadingContainer>
        ) : (
          <ColorProvider variant='brown'>
            <Text size='tera' noMargin {...titleProps}>
              {title}
            </Text>
          </ColorProvider>
        ))}
      {text && (
        <ColorProvider variant='grey'>
          <Text size='kilo' noMargin>
            {text}
          </Text>
        </ColorProvider>
      )}
    </RadioDetails>
    <RadioSelector centered={centered}>
      <Radio isActive={selected === itemId} />
    </RadioSelector>
  </Container>
);

RadioCard.propTypes = {
  itemId: PropTypes.number,
  assetUrl: PropTypes.string,
  title: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  text: PropTypes.string,
  centered: PropTypes.bool,
  titleProps: PropTypes.object,
  selected: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  onSelect: PropTypes.func,
};

export default RadioCard;
